import React, { FC, PropsWithChildren } from 'react';
import styled, { CSSProperties } from 'styled-components';

const Component = styled.svg(({ xs }: { xs: CSSProperties }) => ({
    ...xs,
}));

type SvgIconProps = React.SVGAttributes<HTMLOrSVGElement>;

const SvgIcon: FC<PropsWithChildren<SvgIconProps>> = ({ children, ...props }) => {
    return (
        <Component
            xs={{ height: '1em', verticalAlign: '-0.125em', overflow: 'visible', display: 'inline-block' }}
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            {children}
        </Component>
    );
};

export default SvgIcon;
